'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.color = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('../variables.json'),
    $colorMap = _require.$colorMap; // =============================================================================
// COLORS (Settings)
// =============================================================================
// Example:
// .class {
//   background-color: color('primary', 300);
//   color: color('warning');
// }
// -----------------------------------------------------------------------------


var color = exports.color = function color(_color) {
    var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

    var pickedColor = (0, _dictionary2.default)($colorMap, 'Unknown color used in color function')(_color);
    var pickedColorVariant = (0, _dictionary2.default)(pickedColor, 'Unknown colorVariant used in color function')(variant);
    return pickedColorVariant;
};
//# sourceMappingURL=color.js.map